const countdown = document.querySelector( ".top-header.campaign .countdown-text" );

if ( countdown ) {
	const language = JSON.parse(countdown.dataset.language);
	const countDownDate = new Date( countdown.dataset.dateEnd * 1000 ).getTime();
	const zeroPad = (num, places) => String(num).padStart(places, '0')

	// Update the count down every 1 second
	let x = setInterval( function() {
		// Get today's date and time
		let now = new Date().getTime();

		// Find the distance between now and the count down date
		let distance = countDownDate - now;

		// Time calculations for days, hours, minutes and seconds
		let days = Math.floor( distance / (
			1000 * 60 * 60 * 24
		) );
		let hours = Math.floor( (
			distance % (
				1000 * 60 * 60 * 24
			)
		) / (
			1000 * 60 * 60
		) );
		let minutes = Math.floor( (
			distance % (
				1000 * 60 * 60
			)
		) / (
			1000 * 60
		) );
		let seconds = Math.floor( (
			distance % (
				1000 * 60
			)
		) / 1000 );

		days = zeroPad(days, 2);
		hours = zeroPad(hours, 2);
		minutes = zeroPad(minutes, 2);
		seconds = zeroPad(seconds, 2);

		let text = [];

		text.push(days + language.days);
		text.push(hours + language.hours);
		text.push(minutes + language.minutes);
		text.push(seconds + language.seconds);

		// Display the result in the element with id="demo"
		countdown.innerHTML = text.join(' ');

		// If the count down is finished, write some text
		if ( distance < 0 ) {
			clearInterval( x );

			countdown.innerHTML = "0";
		}
	}, 1000 );
}